module.exports = __webpack_public_path__ + "static/media/55_000034.8389e7c8.jpg";